export default [
  {
    name: 'logo',
    path: 'modules/pages/default/blocks/BlockLogo'
  },
  {
    name: 'title',
    path: 'modules/pages/default/blocks/BlockTitle'
  },
  {
    name: 'text',
    path: 'modules/pages/default/blocks/BlockText'
  },
  {
    name: 'links',
    path: 'modules/pages/default/blocks/BlockLinks'
  },
  {
    name: 'social_networks',
    path: 'modules/pages/default/blocks/BlockSocialNetworks'
  }
]
